<template>
    <div></div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import translate from '../plugins/translate'

const user = createNamespacedHelpers('user')
const interceptor = createNamespacedHelpers('interceptor')
export default {
    name: 'kndSuccessNotify',
    watch:{
        dialogSuccess(value){
            if(value) this.notify()
        }
    },
    methods: {
        ...user.mapActions(['setUser']),
        closeDialogSuccess() {
            this.clearError()
        },
        clearError() {
            this.$store.dispatch('interceptor/clearSuccess')
            this.$store.dispatch('interceptor/closeSuccess')
        },
        notify(){
            this.$notify.success({
                title: translate('Sucesso', 'KndSuccess'),
                message: this.success.data.success,
                onClose: this.closeDialogSuccess,
                onClick: this.closeDialogSuccess
            });
        },

    },
    computed: {
        ...interceptor.mapGetters(['success', 'dialogSuccess']),
    }
}
</script>
<style scoped>
.v-alert{
    margin-bottom: 0 !important;
}
</style>
